import React, { useEffect, useRef, useState } from 'react'

import { DropDownOption } from '@store/types'

import { ChevronUpDownSvg } from '@svg/react'

import useOutsideClick from '@adUtilities/hooks/use-outside-click'

interface Props {
  zoneOptions: Array<DropDownOption>
  activeZone: string
  onChange: (arg: string) => void
  setActiveZone?: (arg: string) => void
}

export default function ZoneDropdown({
  zoneOptions,
  activeZone,
  onChange,
  setActiveZone,
}: Props) {
  const [toggle, setToggle] = useState(false)

  const ref = useRef<HTMLDivElement>(null)

  useOutsideClick({
    ref,
    isOpen: toggle,
    onOutsideClick: () => setToggle(false),
  })

  useEffect(() => {
    if (activeZone === '' && setActiveZone) {
      setActiveZone(zoneOptions[0].value)
    }
  }, [activeZone])

  return (
    <div className="relative inline-block text-left text-sm" ref={ref}>
      <button
        type="button"
        onClick={() => setToggle(!toggle)}
        className="flex h-8 w-8 items-center justify-center rounded-[5px] bg-black/10"
      >
        <ChevronUpDownSvg stroke={2} />
      </button>

      {toggle && (
        <div className="absolute left-0 z-10 w-56 rounded bg-neutralColour text-mainColour shadow-lg">
          {zoneOptions.map((item) => (
            <button
              key={item.value}
              className={`${item.value === activeZone ? 'bg-secondaryColour' : ''} w-full rounded px-4 py-3 text-left text-xl`}
              onClick={() => {
                setToggle(false)
                onChange?.(item.value)
              }}
              type="button"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
